function copyOfferCode(button) {
  const code = button.dataset.bossOfferCode || button.textContent.trim();
  if (!code) return;

  const showCopied = () => {
    button.textContent = 'Copied!';
    button.classList.add('boss-offer__code--success');
    window.setTimeout(() => {
      button.textContent = code;
      button.classList.remove('boss-offer__code--success');
    }, 1000);
  };

  const showError = () => {
    button.textContent = "Couldn't copy";
    button.classList.add('boss-offer__code--error');
    window.setTimeout(() => {
      button.textContent = code;
      button.classList.remove('boss-offer__code--error');
    }, 1200);
  };

  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(code).then(showCopied).catch(showError);
    return;
  }

  const selection = window.getSelection();
  const range = document.createRange();
  range.selectNodeContents(button);
  selection.removeAllRanges();
  selection.addRange(range);

  try {
    document.execCommand('copy');
    selection.removeAllRanges();
    showCopied();
  } catch (error) {
    selection.removeAllRanges();
    showError();
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('.boss-offer__code');
  if (!button) return;

  event.preventDefault();
  copyOfferCode(button);
});
